import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { SharedDataService } from 'app/services/sharedData.service';
import { AlertsService } from 'app/ui-components/alerts/alerts.service';
import { OrderService } from 'app/services/order.service';
import { OrderTotalDtls, PaymentDtls, ProductConfPriceData, ProductDtls, ProductDtlsForReview, ProductName, UserAddress} from 'app/models/products.model';
import { AuthService, Passport } from 'app/services/auth.service';
import * as uuid from 'uuid';
import { UserService } from 'app/users/user.service';
import { finalize } from 'rxjs';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { TrackingService, AbandonCartEvents} from 'app/services/tracking.service';

@Component({
  selector: 'app-order-confirmation',
  templateUrl: './order-confirmation.component.html',
  styleUrls: ['./order-confirmation.component.scss']
})

export class OrderConfirmationComponent implements OnInit {

  dataSource = new MatTableDataSource<ProductConfPriceData>();
  columnsToDisplay: string[] = ['productName', 'price', 'quantity', 'final'];
  @ViewChild(MatTable) table! : MatTable<any>;
  userEmail!: string;
  customerNumber?: string;
  shippingAddr : any = {};
  billingAddr : any = {};
  cardDtls : any = {};
  orderSummaryDtls: any = {};
  prodList: ProductDtlsForReview[] = []; 
  products: [{[key: string]: ProductDtls}] = [{}];
  orderNumber!: string;
  encrOrderNumber!: string;
  showSpinner: boolean = true;
  hasErrors: boolean = false;
  isSmallView: boolean = false;

  constructor(private aRoute: ActivatedRoute,
    private responsive: BreakpointObserver,
    private sharedDataService: SharedDataService,
    private orderService: OrderService,
    private alertService: AlertsService,
    private userService: UserService,
    private authService: AuthService,
    private trackingService: TrackingService,
  ) {}

  ngOnInit() {
    this.determineViewMode();
    this.aRoute.queryParams.subscribe(params => {
        this.encrOrderNumber = decodeURIComponent(params['orderNumber']);
    });
    let token: Passport  = {
      id: uuid.v4(),
      userFlow: 'confirm',
      customerNumber: this.userService.profile.customerNumber
    } 
    this.authService.getToken(token)
         .pipe(
          finalize(() => {
         this.retrieveDetails();
        
         })
        )
        .subscribe(); 
  }

  determineViewMode() {
    this.responsive.observe(Breakpoints.HandsetPortrait)
      .subscribe(result => {
        this.isSmallView = false;
        if(result.matches) {
          this.isSmallView = true;
        }
    });
  }

  retrieveDetails() {
    this.dataSource.data.pop();
    //console.log('this.encrOrderNumber '+ this.encrOrderNumber)
    if(this.encrOrderNumber) {
      this.orderService.getDecryptedOrderNumber(encodeURIComponent(this.encrOrderNumber)).subscribe({
        next: (data: any) => {
          if(data) {
            let resObj;
            try{
              resObj = JSON.parse(data);
            } catch (e) {
              resObj = JSON.parse(JSON.stringify(data));
            }
            this.orderNumber = resObj.Data;
            this.invokeGetOrder();
            this.orderService.requestOrderConfirmationEmail(this.orderNumber).subscribe({
              next: (data: any) => { console.log(data);},
              error: err => { console.log("Error requestion email: " + err.message); }
            })
          } else {
            this.alertService.displayError("Error occured while calling decrypt order, no data returned");
            this.hasErrors = true;
          }
        },
        error: err => {
          this.alertService.displayError("Error occured while calling decrypt order from Advantage"+err.errorMessage);
          this.hasErrors = true;
        }
      });
    } else {
      this.alertService.displayError("Error occured");
    }
    
  }

  invokeGetOrder() {
    if(this.orderNumber) {
      //call getOrder to retrieve details from Advantage
      this.orderService.getOrder(this.orderNumber).subscribe({
        next: (data: any) => {
          if(data) {
           // console.log('Get Order call successful. Data - ' + JSON.stringify(data))
            let resObj;
            try{
              resObj = JSON.parse(data);
            } catch (e) {
              resObj = JSON.parse(JSON.stringify(data));
            }
            this.retrieveDataFromResponse(resObj);
            //clear storage items
            this.clearItems();
          } else {
            this.alertService.displayError("Error occured while calling get order, no data returned");
            this.hasErrors = true;
            this.showSpinner = false;
          }
        },
        error: err => {
          this.alertService.displayError("Error occured while retrieving order from Advantage");//+this.parseErrorMessage(err.error.ErrorMessage));
          console.log('Error occured while calling retrieving order from Advantage '+ err.error.ErrorMessage);//+this.parseErrorMessage(err.error.ErrorMessage));
          this.hasErrors = true;
          this.showSpinner = false;
        }
      });
    } else {
      this.alertService.displayError("Error occured, no order data found");
      this.showSpinner = false;
    }
  }

  retrieveDataFromResponse(data: any) {
    if(data.Data) {
      if(data.Data.Amounts) {
        let orderDtls : OrderTotalDtls = {
          subTotal: data.Data.Amounts.TotalSalesAmount,
          tax: data.Data.Amounts.SalesTax,
          orderTotal: data.Data.Amounts.TotalCost,
          promoDiscount: data.Data.Amounts.TotalDiscount
        };
        Object.assign(this.orderSummaryDtls, orderDtls);
      }
      if(data.Data.BillTo) {
        let billToAddr = this.parseAddressDetails(data.Data.BillTo.AddressBlock);
        Object.assign(this.billingAddr, billToAddr);
        this.userEmail = data.Data.BillTo.EmailAddress;
        this.customerNumber = data.Data.BillTo.CustomerNumber;
      }
      /*if(data.Data.ShipTo) {
        let shipAddr = this.parseAddressDetails(data.Data.ShipTo.AddressBlock);
        Object.assign(this.shippingAddr, shipAddr);
      }*/
      if(data.Data.Payments && data.Data.Payments.length > 0) { 
        let paymnt = data.Data.Payments[0];
        if(paymnt && paymnt.PaymentMethod) {
          let desc : string = paymnt.PaymentMethod.Description;
          let date : string = paymnt.Date;
          let paymentObj : PaymentDtls = {
            method : paymnt.PaymentMethod.PaymentType,
            cardType : desc && desc.includes(' ') ? desc.split(' ')[0].toLowerCase() : '',
            endingNbr : paymnt.PaymentNumberEnding,
            month : date && date.includes('-') ? date.split('-')[1] : '',
            year : date && date.includes('-') ? date.split('-')[0] : ''
          }
          Object.assign(this.cardDtls, paymentObj);
        }
      }
      if(data.Data.Lines) {
        let prodObjList : ProductConfPriceData[] = [];
        for(var line of data.Data.Lines) {
          var itemNumber = line.ItemNumber;
          const prodName = ProductName[itemNumber];
          let prodSummaryObj : ProductDtlsForReview = {
            itemNumber: itemNumber,
            productName: prodName? prodName : itemNumber,
            quantity: line.QuantityOrdered,
            term: line.Access?.ServicePeriodCode? line.Access?.ServicePeriodCode.substring(2).replace(/0/gi,''): ''
          };
          this.prodList.push(prodSummaryObj);
          let prodObj : ProductConfPriceData = {
            productName: prodName? prodName : itemNumber,
            price : line.UnitPrice,
            quantity: line.QuantityOrdered,
            final: line.TotalCost
          }
          prodObjList.push(prodObj);
        }
        this.dataSource.data = prodObjList;
      }
      this.updateTrackingInfo();
    } else {
      if(data.ErrorMessage) {
        //let errMsg = this.parseErrorMessage(data.ErrorMessage);
        let errMsg = data.ErrorMessage;
        this.alertService.displayError(errMsg);
        this.hasErrors = true;
      }
    }
    this.showSpinner = false;
  }

  parseAddressDetails(addr: string) : UserAddress{
    let addrList = addr ? addr.split('<br />') : ''; 
    let len = addrList.length;
    let field2, field3;
    if(len === 5) {
      field2 = addrList[len-3];
    } else if(len === 6) {
      field2 = addrList[len-4];
      field3 = addrList[len-3]
    }
    
    let addrObj : UserAddress = {
      name : addrList[0] ? addrList[0] : '',
      field1: addrList[1] ? addrList[1] : '',
      field2: field2? field2 : '',
      field3: field3? field3 : '',
      cityStateZip : addrList[len-2] ? addrList[len-2] : ''
    }
    return addrObj;
  }

  clearItems() {
    this.sharedDataService.setQuantity(0);
    this.sharedDataService.setCartProducts([{}], true);
    this.sharedDataService.setOrderNumber('', true);
    this.sharedDataService.setPromoCodeForUpdate('', true);
    this.sharedDataService.setPromoCodes([], true);
    this.sharedDataService.setOrderReviewItems([], true);
    sessionStorage.removeItem('address');
    sessionStorage.removeItem('company');
    sessionStorage.removeItem('quantity');
  }

  parseErrorMessage(msg: string): string {
    return msg.substring(msg.lastIndexOf(`,\"Message\":\"`)+12, msg.lastIndexOf(`\",\"WorkerId\"`));
  }

  getTerm(term: string) {
    return term + ((term === '1') ? " Year": " Years");
  }  

  private updateTrackingInfo() {
    console.log (`Order Confirmation Start updateTrackingInfo this.customerNumber ${this.customerNumber}`);
    this.trackingService.upsertEvent({
         customerNbr: this.customerNumber,
         orderNumber: this.orderNumber,
         events: [{ trackingEvent: AbandonCartEvents.ORDER_SUBMITTED}],
    });
  
  }
}
